// Per-route SEO data for The Next Stage marketing site.
// Used by the <Seo /> component (react-helmet-async) and consumed by
// react-snap at build-time so crawlers receive fully-rendered meta tags.

export const SITE_URL = "https://thenextstageshow.com";
export const SITE_NAME = "The Next Stage";

// Default OG / Twitter card image — 3D trophy hero used as the brand mark.
export const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_f0e0f3d1-c9ec-4750-9cbc-656067fbc606/artifacts/g1mosp5t_The_Next_Stage_3D_Hero_Logo.jpg";

const TITLE_SUFFIX = " · The Next Stage";

export const SEO = {
  "/": {
    title: "Public Speaking Showcase · Colorado Springs",
    description:
      "The Next Stage is a live, judged public speaking showcase produced by The Next Stage Media Group, LLC in Colorado Springs. Pilot One: Fall 2026. Pilot Two: Early 2027.",
    keywords:
      "public speaking competition, Colorado Springs, speaker showcase, The Next Stage, The Next Stage Media Group, speaker pipeline, live event",
  },
  "/about": {
    title: "About",
    description:
      "A platform built for emerging speakers who treat communication as a craft. Real stage. Real judging. Real pipeline — produced by The Next Stage Media Group, LLC.",
    keywords:
      "about The Next Stage, R. Dale Brunet, The Next Stage Media Group, speaker platform, Colorado Springs",
  },
  "/apply": {
    title: "Apply To Speak",
    description:
      "Apply to step onto The Next Stage. A serious stage for serious messages. Tell us about you, your message, and why now.",
    keywords:
      "apply to speak, contestant application, public speaking audition, Colorado Springs speaker",
  },
  "/sponsor": {
    title: "Sponsor The Next Stage | Public Speaking Showcase Sponsorship",
    description:
      "Sponsor The Next Stage, a Colorado Springs public speaking competition and showcase elevating emerging speakers, entrepreneurs, storytellers, authors, advocates, and community leaders.",
    keywords:
      "The Next Stage sponsor, Colorado Springs event sponsorship, public speaking showcase sponsor, entrepreneur event sponsorship, speaker competition sponsor, community event sponsorship Colorado Springs, leadership event sponsor, storytelling event sponsor",
  },
  "/attend": {
    title: "Attend",
    description:
      "Be in the room when emerging speakers step forward. Reserve your seat for Pilot Event One — Fall 2026 — and beyond.",
    keywords:
      "attend public speaking event, Colorado Springs event tickets, live showcase audience",
  },
  "/partners": {
    title: "Community Partners",
    description:
      "Built with Colorado Springs leaders, organizations, and audiences. Partner with The Next Stage to develop the region's next generation of communicators.",
    keywords:
      "community partners, Colorado Springs nonprofit partners, speaker development partners",
  },
  "/news": {
    title: "News & Updates",
    description:
      "Announcements, milestones, and behind-the-scenes notes from The Next Stage and Use What You Got Publishing.",
    keywords:
      "The Next Stage news, public speaking event updates, Colorado Springs event announcements",
  },
  "/faq": {
    title: "Frequently Asked Questions",
    description:
      "What The Next Stage is, who it's for, how the judging works, and what to expect on event day.",
    keywords:
      "public speaking FAQ, contestant questions, sponsor questions, event details",
  },
  "/contact": {
    title: "Contact",
    description:
      "Reach the team behind The Next Stage. Inquiries from contestants, sponsors, vendors, media, and community partners welcome.",
    keywords:
      "contact The Next Stage, info@TheNextStageShow.com, UWYG Publishing contact",
  },
  "/privacy": {
    title: "Privacy Policy",
    description:
      "How The Next Stage and Use What You Got Publishing handle information submitted through this site.",
    keywords: "privacy policy, data handling, The Next Stage privacy",
  },
  "/terms": {
    title: "Terms of Use",
    description:
      "Terms governing use of TheNextStageShow.com and participation in The Next Stage events.",
    keywords: "terms of use, terms of service, The Next Stage terms",
  },
  "/accessibility": {
    title: "Accessibility",
    description:
      "Our commitment to an accessible experience for every visitor, contestant, sponsor, and audience member.",
    keywords: "accessibility statement, ADA, inclusive event",
  },
  "/media-group": {
    title: "About The Next Stage Media Group, LLC",
    description:
      "The Next Stage Media Group, LLC is the production, management, media, and rights-holding company behind The Next Stage. A founder-led platform identifying, developing, and amplifying emerging voices through live events and media.",
    keywords:
      "The Next Stage Media Group, TNS Media Group, R. Dale Brunet, public speaking production company, live event production Colorado Springs, media rights holding company, emerging speakers platform",
  },
};

export function getSeoForPath(pathname) {
  const cfg = SEO[pathname] || SEO["/"];
  const title =
    pathname === "/"
      ? `${cfg.title}${TITLE_SUFFIX.replace(" · ", " · ")}`.replace(
          " · ",
          " · ",
        )
      : `${cfg.title}${TITLE_SUFFIX}`;
  return {
    title:
      pathname === "/"
        ? `${SITE_NAME} · ${cfg.title}`
        : `${cfg.title}${TITLE_SUFFIX}`,
    description: cfg.description,
    keywords: cfg.keywords,
    canonical: `${SITE_URL}${pathname === "/" ? "" : pathname}`,
    image: DEFAULT_OG_IMAGE,
  };
}

// Routes react-snap should crawl/prerender at build time.
export const ALL_ROUTES = Object.keys(SEO);
